<template>
    <div class="zuke_index">
        
        <div class="head_box">
            <div class="head_top_box">
                <div class="head_top">
                    <a href="javascript:history.back(-1)"><img src="../../assets/images/left.png" alt=""></a>
                    <div class="seatch">
                        <input type="text" v-model.trim="search" placeholder="请输入您要搜索的词条">
                        <img @click='search_input' src="../../assets/images/search/search_top.png" alt="">
                    </div>
                </div>
                <div class="seatch_btn">
                    <div class="search_btn_list" @click='search_btn(1)' :class='search_index == 1 ? "active" : ""'>小区<p></p></div>
                    <div class="search_btn_list" @click='search_btn(2)' :class='search_index == 2 ? "active" : ""'>公司<p></p></div>
                    <div class="search_btn_list" @click='search_btn(3)' :class='search_index == 3 ? "active" : ""'>商圈<p></p></div>
                    <div class="search_btn_list" @click='search_btn(4)' :class='search_index == 4 ? "active" : ""'>品牌公寓<p></p></div>
                    <div class="search_btn_list" @click='search_btn(5)' :class='search_index == 5 ? "active" : ""'>写字楼<p></p></div>
                    <div class="search_btn_list" @click='search_btn(6)' :class='search_index == 6 ? "active" : ""'>商业综合体/商铺<p></p></div>
                    <div class="search_btn_list" @click='search_btn(7)' :class='search_index == 7 ? "active" : ""'>创业孵化器<p></p></div>
                    <div class="search_btn_list" @click='search_btn(8)' :class='search_index == 8 ? "active" : ""'>物业公司<p></p></div>
                    <div class="search_btn_list"></div>
                </div>
            </div>
        </div>
        
        
        <!-- 搜索历史 -->
        <div class="history_box" v-if="history.length > 0">
            <h2 class="history_title">最近搜索</h2>
            <div class="del_img" @click="del_history"><img src="../../assets/images/search/del.png" alt=""></div>
            <div class="history_list_box">
                <div class="shistory_list" v-for="history in history" v-if="history != ''">
                    <router-link :to="{name:'baike_list',params:{type:type + '.html'},query:{search:history}}">{{history}}</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "baike_search",
        data:()=>{
            return {
                search_index:1,
                // 搜索历史
                history:[],
                search:'',
                // 搜索类型
                type:'xq',
                // 搜索类型数组
                typearr:["xq","company","sq","apartment","office","shop","incubator","wygs"],
            }
        },
        components:{
            
        },
        mounted(){
            var index = this.$route.params.name
            if(index){
                this.search_index = index
                this.type = this.typearr[index-1]
            }
            // 查询历史记录
            var arr = JSON.parse(localStorage.getItem('history_arr'))
            if(!arr){
                arr = []
            } else {
                for(var i = 0; i < arr.length; i++){
                    // console.log(!arr[i])
                    if(!arr[i]){
                        arr.splice(i,1)
                        i--
                    }
                }
            }
            
            this.history = arr
        },

        methods:{
            // 点击切换选项
            search_btn(num,name){
                this.search_index = num
                this.type = this.typearr[num-1]
                if(this.search != ""){
                    this.$router.push({
                        name:'baike_list',
                        params:{
                            type:this.type+'.html',
                        },
                        query:{
                            search:this.search,
                        },
                    })
                }
            },
            // 删除历史记录
            del_history(){
                localStorage.setItem('history_arr',JSON.stringify([]))
                this.history = []
            },
            // 判断是否填写了内容   填写了存储数据之后直接跳转
            search_input(){
                if(!this.search){
                    this.$router.push({
                        name:'baike_list',
                        params:{
                            type:this.type+'.html',
                        },
                    })
                } else {
                    this.$router.push({
                        name:'baike_list',
                        params:{
                            type:this.type+'.html',
                        },
                        query:{
                            search:this.search,
                        },
                    })
                }
            }
        },
        created() {
            
        }
    }
</script>

<style scoped>
    
    .head_top_box {
        width: 100%;
        z-index: 100;
    }
    
    .head_top {
        display: flex;
        align-items: center;
        width: 100%;
        min-width: 8rem;
        max-width: 16rem;
        margin: 0 auto;
        height: 1.877333rem;
        background-color: #fff;
    }
    
    .head_top>a {
        display: block;
        width: 2.133333rem;
        height: 1.877333rem;
    }
    
    .head_top a img {
        display: block;
        height: 1.28rem;
        margin: 0 auto;
        padding: 0.298666rem;
    }
    
    .head_top .seatch {
        display: flex;
        align-items: center;
        flex: 1;
        height: 1.28rem;
        background-color: #f9f9f9;
        margin-right: 1.002666rem;
        border-radius: 0.128rem;
    }
    
    .head_top .seatch input {
        display: block;
        flex: 1;
        height: 100%;
        margin-left: 0.426666rem;
        background-color: #f9f9f9;
        border: 0;
    }
    
    .head_top .seatch img {
        width: 0.704rem;
        height: 0.704rem;
        padding: 0.298666rem 0.426666rem;
    }
    
    .seatch_btn {
        display: flex;
        width: 100%;
        height: 1.55rem;
        padding-top: 0.298666rem;
        overflow-x: scroll;
        background-color: #fff;
        border-bottom: 1px solid #ddd;
    }
    
    .seatch_btn::-webkit-scrollbar {
        display: none;
    }
    
    .seatch_btn .search_btn_list {
        flex-shrink: 0;
        height: 1.450666rem;
        line-height: 1.450666rem;
        margin: 0 0.746666rem;
        color: #333;
        font-size: 0.682666rem;
        padding: 0 0.277333rem;
        border-bottom: 1px solid rgba(0,0,0,0);
    }
    
    .seatch_btn .search_btn_list.active {
        color: #3fabfa;
        border-bottom: 2px solid #3fabfa;
    }
    
    .seatch_btn .search_btn_list:last-child {
        margin-left: 0;
    }
    
    /* 搜索历史 */
    .history_box {
        position: relative;
        padding: 1.024rem 0.512rem 0;
    }
    
    .history_title {
        width: 100%;
        font-size: 0.554666rem;
        color: #666;
        font-weight: 500;
        margin-bottom: 0.426666rem;
    }
    
    .del_img {
        position: absolute;
        top: 0.896rem;
        right: 0.597333rem;
        width: 0.789333rem;
        height: 0.768rem;
    }
    
    .del_img img {
        width: 100%;
        height: 100%;
    }
    
    .history_list_box {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    
    .shistory_list {
       padding: 0.384rem;
       font-size: 0.597333rem;
       color: #333;
       background-color: #f3f5f7;
       border-radius: 0.213333rem;
       margin-right: 0.426666rem;
       margin-bottom: 0.426666rem;
    }
    
    .shistory_list:last-child {
       margin-right: 0;
    }
</style>


// WEBPACK FOOTER //
// search.vue